import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <p className={styles.footerText}>
          © 2025 Handsome Technologies, LLC • Professional resumes that make an impression
        </p>
      </div>
    </footer>
  );
};

export default Footer;
